namespace RioERP.Invoices {
    export interface FinancialYearRow {
        Id?: number;
        YearCode?: string;
        FromDate?: string;
        ToDate?: string;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace FinancialYearRow {
        export const idProperty = 'Id';
        export const nameProperty = 'YearCode';
        export const localTextPrefix = 'Invoices.FinancialYear';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            YearCode = "YearCode",
            FromDate = "FromDate",
            ToDate = "ToDate",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
